export default "__VITE_ASSET__DISgXwQy__"